export type WorkstationSchema = {
  id: string;
  restaurant_id: string;
  name: string;
  control_station_id: string;
  // Kitchen load points per item action routed through this station
  // (e.g. fry = 3, rice = 1, assembly = 0). Feeds the load-aware wait
  // estimate. Optional: absent when the backend predates the field.
  prep_weight?: number;
};

export type CreateWorkstationSchemaRequest = {
  name: string;
};

export type UpdateWorkstationSchemaRequest = {
  name: string;
};

export type SetWorkstationPrepWeightRequest = {
  prep_weight: number;
};

// Mirrors the backend's maxPrepWeight validation bound.
export const MAX_PREP_WEIGHT = 100;
